﻿
import onReady from '../utils/onReady';
import { delegateEvent } from '../utils/events';


/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class MyWaitingList {

	/**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
	constructor(container) {
		// Run initializing code once the DOM is ready.
		onReady(() => this.init(container));
	}


	addEvents() {
		
		delegateEvent(".deleteSectionBtn", "click", (ev) => {
			ev.event.preventDefault();

			if (confirm('Er du sikker på du vil slette denne boligafdeling fra din venteliste?'+'\n\n' + 'OBS! Hvis du sletter alle afdelinger i denne boligorganisation får du ingen boligtilbud. Du bør i stedet ændre din status til at være ikke aktivt boligsøgende.')) {

				let sectionid = ev.target.getAttribute("data-sectionid");
				let journalid = ev.target.getAttribute("data-journalid");
				let leasetypeid = ev.target.getAttribute("data-leasetypeid");

				this.dom.submitDeleteSectionID.value = sectionid;
				this.dom.submitDeleteJournalID.value = journalid;
				this.dom.submitDeleteLeaseTypeID.value = leasetypeid;

				let form = this.dom.container.querySelector("form");
				//form.setAttribute("action", "/api/sitecore/MyWaitingList/DeleteLease");
				form.submit();
			}
		});


		delegateEvent(".deleteOrgBtn", "click", (ev) => {
			ev.event.preventDefault();

            if (confirm('Er du sikker på, at du vil slette denne fra din venteliste?' + '\n' + '(Familie-, ungdoms- eller ældrebolig)' + '\n\n' + 'Hvis du sletter, står du ikke længere på ventelisten til denne type bolig i boligorganisationen.')) {

				let journalid = ev.target.getAttribute("data-journalid");
				let deleteorg = ev.target.getAttribute("data-deleteorg");

				this.dom.submitDeleteJournalID.value = journalid;
				this.dom.submitDeleteOrganisation.value = deleteorg;

				let form = this.dom.container.querySelector("form");
				//form.setAttribute("action", "/api/sitecore/MyWaitingList/DeleteWaitingList");
				form.submit();
			}
		});


	}
	
	/**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
	init(container) {
		this.dom = {
			container // ES6 allows this syntax instead of writing "container: container"
		};

		// Put your other DOM-specific initializations here, and get your class moving!

		this.dom.floorSelects = this.dom.container.querySelectorAll(".form-basket__select");
		this.dom.submitButton = this.dom.container.querySelector(".buttonSubmit");
        

		this.dom.submitDeleteJournalID = this.dom.container.querySelector("#SubmitDeleteJournalID");
		this.dom.submitDeleteSectionID = this.dom.container.querySelector("#SubmitDeleteSectionID");
		this.dom.submitDeleteLeaseTypeID = this.dom.container.querySelector("#SubmitDeleteLeaseTypeID");
		this.dom.submitDeleteOrganisation = this.dom.container.querySelector("#SubmitDeleteOrganisation");

		this.dom.deleteSectionBtns = this.dom.container.querySelectorAll(".deleteSectionBtn");
		this.dom.deleteOrgBtns = this.dom.container.querySelectorAll(".deleteOrgBtn");

		this.addEvents();
	}
}


export default MyWaitingList;
